var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"columns":_vm.d_columns_bill,"height":"300","border":"","data":_vm.d_data_bill}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }